// Lightweight analytics helpers for Google Analytics (gtag) and Meta Pixel (fbq)

export const trackEvent = (name: string, params: Record<string, any> = {}) => {
  try {
    // Google Analytics (gtag)
    if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', name, params);
    }
    
    // Meta Pixel (fbq)
    if (typeof window !== 'undefined' && typeof (window as any).fbq === 'function') {
      (window as any).fbq('trackCustom', name, params);
    }
    
    // Dev logging
    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics]', name, params);
    }
  } catch {
    // no-op
  }
};

export const trackPageView = (page_title?: string, page_path?: string) => {
  trackEvent('page_view', {
    ...(page_title ? { page_title } : {}),
    ...(page_path ? { page_path } : {}),
  });
};

export const withAnalytics = <T extends (...args: any[]) => any>(
  fn: T,
  eventName: string,
  params: Record<string, any> = {}
) => {
  return (...args: Parameters<T>) => {
    trackEvent(eventName, params);
    return fn(...args);
  };
};
